import { HasAddressRecord } from '../../repos/table.repo';

export interface WaterRegistrationModel extends HasAddressRecord {
    name: string;
    representative: string;
    title: string;
    officeAddress: string;
    mobilePhone: string;
    landlinePhone: string;
    email: string;
    taxCode: string;
    bankNo: string;
    bankName: string;
    provinceId: string;
    districtId: string;
    wardId: string;
    address: string;
    estimateAmoutWater: number;
    reason: string;
    identification: string;
    identificationDate?: string;
    waterFactoryId: string;
    unitTypeId: string;
    status: string;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
}


export class WaterRegistrationModelFactory {
    static getEmpty(): WaterRegistrationModel {
        return {
            id: "",
            name: "",
            representative: "",
            title: "",
            officeAddress: "",
            mobilePhone: "",
            landlinePhone: "",
            email: "",
            taxCode: "",
            bankNo: "",
            bankName: "",
            provinceId: "",
            districtId: "",
            wardId: "",
            address: "",
            estimateAmoutWater: 0,
            reason: "",
            identification: "",
            waterFactoryId: "",
            unitTypeId: "",
            status: "",
            createdAt: "",
            createdBy: "",
            updatedAt: "",
            updatedBy: "",
        }
    }
}